/*
 * @Description: 案例审核列表
 * @Author: hanpengtao
 * @Date: 2022-04-25 11:15:36
 */
import React, { useState, useEffect } from 'react';
import { message, Table, Button } from 'antd';
import ListFilter from './components/ListFilter/index';
import EditModal from './components/EditModal/index';
import ExaminationFailedReasonModal from './components/ExaminationFailedReasonModal/index';
import { classifyCheckList, auditCase, getNextCaseId } from "@/api";
import './index.less';

const Status = ['未审核', '已审核', '审核不通过', '已下架'];
const Sourse = ['自营爬取', '用户上传', '运营导入'];

const CaseCheck = () => {
  const [requestParams, setRequestParams] = useState({
    page: 1,
    pageSize: 20,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [visible, setVisible] = useState(false);
  const [caseId, setCaseId] = useState(null);
  const [examineMode, setExamineMode] = useState(false); // 是否是审核弹框
  const [examinationFailedVisible, setExaminationFailedVisible] = useState(false); // 控制审核失败原因弹框

  useEffect(() => {
    handleQuery({
      page: 1,
      reviewStatus: '0',
      caseId: null,
      classifyId: null,
      endTime: '',
      reviewAccountId: null,
      reviewEndTime: '',
      startTime: '',
      reviewStartTime: '',
      sourceType: 0,
      title: null
    });
  }, []);
  //获取下一个案例的caseId
  const handleNext =  async() => {
    const res = await getNextCaseId();
    setCaseId(res.data);
  }
  const handleQuery = (params) => {
    let newParams = {
      ...requestParams,
      ...params,
    };
    delete newParams.total;

    getClassifyCheckList(newParams);
  }

  const getClassifyCheckList = async (params) => {
    try {
      setLoading(true);
      let res = await classifyCheckList(params);
      if (res?.error?.errorCode == 0) {
        if (res?.data?.contents?.length) {
          setDataSource(res?.data?.contents);
          setRequestParams({
            ...params,
            total: res?.data?.total
          });
        } else {
          setDataSource([]);
          setRequestParams({
            ...requestParams,
            total: 0,
          });
          message.error('暂无数据');
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const modify = (record, examine) => {
    
    setCaseId(record.caseId);
    setVisible(true);
    setExamineMode(examine)
  }
  // 下架
  const offShelf = (record) => {
    setCaseId(record.caseId);
    setExaminationFailedVisible(true)
  }

  const columns = [
    {
      title: "序号",
      width: '8%',
      render: (text, record, index) => index + 1
    },
    {
      title: '来源',
      dataIndex: 'sourceType',
      width: '8%',
      render: (v) => (<span>{Sourse[v]}</span>)
    },
    {
      title: 'CASE_ID',
      dataIndex: 'caseId',
      width: '8%',
    },
    {
      title: '分类',
      dataIndex: 'classifyList',
      width: '12%',
      render: (v) => (
        <div className="classifyStyle">
          {
            v.map((item, i) =>
              `${item.rootName ? item.rootName : ''}${item.rootName ? '-' : ''}${item.parentName ? item.parentName : ''}${item.parentName ? '-' : ''}${item.name}${(v.length - 1) != i ? ',' : ''}`
            )
          }
        </div>
      )
    },
    {
      title: '案例发布时间',
      dataIndex: 'publishTime',
      width: '12%',
    },
    {
      title: '案例标题',
      dataIndex: 'titleOrigin',
      width: '12%',
      render: (v) => (<div className="classifyStyle">{v}</div>)
    },
    {
      title: '状态',
      dataIndex: 'reviewStatus',
      width: '10%',
      render: (v) => (<span>{Status[v]}</span>)
    },
    {
      title: '审核日期',
      dataIndex: 'reviewTime',
      width: '12%',
    },
    {
      title: '操作',
      dataIndex: 'opt',
      width: '12%',
      render: (_, record) => (!record.sourceType ? <><Button onClick={() => modify(record, false)}>编辑</Button>
       {/* <Button onClick={() => offShelf(record)}>下架</Button> */}
       </> 
       : record.reviewStatus == 1 ? <><Button onClick={() => modify(record, false)}>编辑</Button> 
       {/* <Button onClick={() => offShelf(record)}>下架</Button> */}
       </> 
       : <Button onClick={() => modify(record, true)
      }>审核</Button>)
    }
  ];

  const pagination = {
    total: requestParams.total,
    current: requestParams.page,
    pageSize: requestParams.pageSize,
    onChange: (page) => handleQuery({ page }),
  }

  return (
    <div className='caseCheck'>
      <h2 className='title'>案例审核</h2>
      <ListFilter handleQuery={handleQuery} />
      <Table
        rowKey='caseId'
        loading={loading}
        columns={columns}
        dataSource={dataSource}
        pagination={pagination}
      />
      <EditModal
        caseId={caseId}
        visible={visible}
        setVisible={setVisible}
        handleQuery={handleQuery}
        examineMode={examineMode}
        handleNext={handleNext}
      />
      <ExaminationFailedReasonModal examinationFailedVisible={examinationFailedVisible} setExaminationFailedVisible={setExaminationFailedVisible} offShelf={true} setVisible={setVisible} caseId={caseId} 
      handleQuery={handleQuery} />
    </div>
  );
}

export default CaseCheck;